const TaskIcon = () => {
  return (
    <svg className="task-edit" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2133_108)">
        <path d="M11.4167 7.33333H7.33341C7.024 7.33333 6.72725 7.45625 6.50846 7.67504C6.28966 7.89384 6.16675 8.19058 6.16675 8.5V16.6667C6.16675 16.9761 6.28966 17.2728 6.50846 17.4916C6.72725 17.7104 7.024 17.8333 7.33341 17.8333H15.5001C15.8095 17.8333 16.1062 17.7104 16.325 17.4916C16.5438 17.2728 16.6667 16.9761 16.6667 16.6667V12.5833" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.7917 6.45833C16.0238 6.22627 16.3386 6.0959 16.6667 6.0959C16.9949 6.0959 17.3097 6.22627 17.5417 6.45833C17.7738 6.6904 17.9042 7.00514 17.9042 7.33333C17.9042 7.66152 17.7738 7.97627 17.5417 8.20833L12.0001 13.75L9.66675 14.3333L10.2501 12L15.7917 6.45833Z" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2133_108">
          <rect width="14" height="14" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TaskIcon